module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spaceselect level-left"
  }, [_c('ui-select', {
    attrs: {
      "label": "",
      "placeholder": "Select Space",
      "options": _vm.spaceList
    },
    on: {
      "select": _vm.spaceSelected
    },
    model: {
      value: (_vm.selectedSpace),
      callback: function($$v) {
        _vm.selectedSpace = $$v
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a17f786!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/spaces/Spaceselect.vue
// module id = 509
// module chunks = 22